import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button, Col, Empty, Row } from "antd";
import Icofont from "react-icofont";
import { errorCatch, READWITH, QueryDetail, QueryParam, JSXMap, JSXPathMap, READ, IfElse, GET, QueryOrder, GetAnswer } from '../../components/Tool'
import { Link, Outlet, useParams } from 'react-router-dom';
import { useAuth } from '../../components/Auth';
import { useContext, useServiceContext, useUserContext } from '../../components/Context';
import moment from 'moment';
import Question from '../Question';

var _ = require('lodash');

function LineDescription(props) {
    const { title, value, unit, bold } = props;
    return (
        <div>
            <span style={(bold) ? { fontWeight: "600", fontSize: "18px" } : {}}>
                {title} {value} {unit}
            </span>
        </div>
    );
}
export default function ServiceDone(props) {
    let { id } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const context = useContext();
    const service = useServiceContext();
    const [sortDefinition, setSortDefinition] = useState();

    useEffect(() => {
        // GET(auth, "/api/context/new",
        //     (res) => setContext(res.data),
        //     errorCatch
        // );
        // GET(auth, "/api/context/last",
        //     (res) => setContext(res.data),
        //     errorCatch
        // );
    }, []);
    useEffect(() => {
        if (context) {
            GET(auth, `/api/sort-definition/${context.ID}`,
                (res) => setSortDefinition(res.data),
                errorCatch
            );
        }
    }, [context]);
    const answers = GetAnswer(context, 1);
    return (<>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
            <Col className="gutter-row" span={24}>
            {JSXMap(answers, (q, idx) => (
                    <div key={idx} style={{ fontWeight: "600", fontSize: "22px", color: "rgb(114, 114, 114)" }}>
                        Культура: {q.answerDisplay}
                    </div>
                ))}
                <div style={{ fontWeight: "600", fontSize: "20px", color: "rgb(114, 114, 114)" }}>
                    Рекомендуемые сорта:
                </div>
                {(!sortDefinition || sortDefinition.length <= 0) && <div>
                    <span style={{color:"red", fontSize:"18px"}}>Не удалось подобрать сорт по указанным параметрам</span>
                    {/* <Empty description={"Не удалось подобрать сорт по указанным параметрам"} style={{ paddingTop: "20px" }} /> */}
                </div>}
                {JSXMap(sortDefinition, (q, idx) => (
                    <div key={idx} style={{ paddingBottom: "5px" }}>
                        <Link
                            // target={"_blank"} 
                            // rel="noreferrer noopener"
                            to={""+q.ID}>
                            <LineDescription value={q.name} bold={true} />
                        </Link>
                    </div>
                ))}
            </Col>
        </Row>
    </>);
}